import { Component, OnInit } from '@angular/core';
import {TripService} from "../../services/trip.service";
import * as _ from 'underscore';

@Component({
  selector: 'app-your-trip',
  templateUrl: './your-trip.component.html',
  styleUrls: ['./your-trip.component.scss']
})
export class YourTripComponent implements OnInit {
  ts;
  trip;
  agencies;
  attractions;
  guides;
  accommodations;
  locations;
  acc; //accounting module
  editingDate = false;
  editingTravelers = false;
  planChildren = false;
  planStudents = false;

  constructor(
    private tripService: TripService
  ) {
    this.ts = tripService;
    this.acc  = tripService.acc;
  }

  minDate1;
  minDate2;
  minDate3;
  minDate4;

  ngOnInit() {
    let that = this;
    that.minDate1 = that.minDate2 = that.minDate3 = that.minDate4 = new Date();

    that.ts.getOne('6f9a9150-d76c-11e7-b1c3-ef42b840cea9').subscribe(res => {
      that.trip = res.data.details.instance;
      that.attractions = res.data.details.wishList.attractions;
      that.guides = res.data.details.wishList.guides || [];
      that.accommodations = res.data.details.wishList.accommodations || [];
      that.locations = res.data.details.wishList.locations || [];
      that.trip = res.data.details.instance;
      that.ts.settings = res.data.settings;
      that.ts._statusPlan = that.trip.statusPlan;
      that.setupService();
      /* Process each section */

      that.verifyMethods();
    });
  }

  setupService(){
    let that = this;

  }

  verifyMethods(){
    let that = this;
    that.ts.getNumberOfPeakNights(1525910400000,1526947200000);
  }

  setStatusPlan(status){
    this.trip.statusPlan = status;
  }

  toggleDateEditing(mode){
    this.editingDate = mode;
  }

  toggleTravellersEditing(mode){
    this.editingTravelers = mode;
  }

  toggleChildrenPlan(mode){
    this.planChildren = mode;
  }
  toggleStudentsPlan(mode){
    this.planStudents = mode;
  }

  checkPicker(){
    if(this.trip.endDate < this.trip.startDate){
      this.trip.endDate = null;
    }
  }

  resetTrip(){
    let that = this;
    that.trip = {
      statusPlan: that.ts.settings.STATUS_PLAN_INIT,
      startDate: null,
      endDate: null,
      numberOfTravelers: null,
      numberOfChildren: null,
      numberOfYoungChildren: null,
      numberOfStudents: null,
      numberOfHotelRooms: null,
      agencyId: null,
      languages: [],
      id: that.trip.id
    };
    that.editingDate = false;
    that.editingTravelers = false;
    that.planChildren = false;
    that.planStudents = false;
    that.agencies = [];
    that.attractions = [];
    that.guides = [];
    that.accommodations = [];
    that.locations = [];
    that.saveTrip();
  };



  saveTrip(){
    let that = this;
    that.ts.saveOne({instance: that.trip}).subscribe(res => {
      //console.log(res);
    });
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/your-trip/your-trip.component.ts